import {createContext, memo, type ReactNode} from 'react'
import {useParticipants} from '@livekit/components-react'
import {useMultiParticipantSpeaking} from './useMultiParticipantSpeaking'

export const SpeakingContext = createContext<Map<string, boolean>>(new Map())

interface SpeakingProviderProps {
  children: ReactNode
}

export const SpeakingProvider = memo(function SpeakingProvider({children}: SpeakingProviderProps) {
  const participants = useParticipants()
  const speakingMap = useMultiParticipantSpeaking(participants)
  return <SpeakingContext.Provider value={speakingMap}>{children}</SpeakingContext.Provider>
})
